import React from 'react';
import * as api from '../../api';
import { useTranslation } from 'react-i18next';
import Spinner from '../../Plateforme/Atoms/Spinner';
import BoldBlue from '../Atoms/BoldBlue';
import Popup from '../Atoms/Popup';
import H2 from '../Atoms/H2';
import Input from '../Atoms/Input';
import BlueButton from '../Atoms/BlueButton';

const AddCollaborator = (props) => {

    const [popupOpen, setPopupOpen] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [status, setStatus] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const { i18n } = useTranslation('common');

    React.useEffect(() => {
        setLoading(false);
        setEmail("");
        setStatus("");
    }, [popupOpen]);

    function addCollaborator(e){
        e.preventDefault();
        if(!email?.includes('@')) {
            alert(i18n.language === "fr" ? "Veuillez renseigner un email valide" : "Please enter a valid email");
            return;
        }
        setLoading(true);
        api.InviteCollaborator({email, inviter : props.inviter}).then((response) => {
            // console.log(response.data);
            setLoading(false);
            if(response.data === "ok") setStatus(i18n.language === "fr" ? "Invitation envoyée !" : "Invitation sent !");
            if(response.data === "user already registered") setStatus(i18n.language === "fr" ? "Cette personne est déjà inscrite sur la plateforme" : "This person is already a registered on the platform");
        }).catch((error) => {
            console.log(error);
            setLoading(false);
            setStatus(i18n.language === "fr" ? "Une erreur est survenue" : "An error occured");
        });
    }


    return (
        <>
            <BoldBlue style={{cursor:"pointer"}} onClick={() => setPopupOpen(true)}>{i18n.language === "fr" ? "Ajouter un collaborateur" : "Add a partners"} +</BoldBlue><br/><br/>
            {popupOpen && <Popup close={() => setPopupOpen(false)}>
                <H2>{i18n.language === "fr" ? "Ajouter un collaborateur" : "Add a partner"}</H2><br/>
                <span>{i18n.language === "fr" ? "Pour ajouter un collaborateur, envoyez-lui une invitation d'inscription en renseignant son email ci-dessous. Une fois inscrit, il apparaitra dans la liste des collaborateurs de la société." : "To add a partner, you can send him an invitation by filling in his email below. Once registered, he will appear in the list of partners of the company."}</span><br/>
                <Input type="email" onChange={(e) => setEmail(e.target.value)} required style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Email du collaborateur" : "Email of the partner"}/><br/>
                {loading ? <Spinner/> : (status ? <span className='centered'>{status}</span> : <BlueButton onClick={addCollaborator}>{i18n.language === "fr" ? "Ajouter" : "Add"}</BlueButton>)}
            </Popup>}
        </>
    );
}

export default AddCollaborator;